"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = ["id"];
const _hoisted_4 = ["id"];
const _hoisted_5 = ["id"];
const tagStore_1 = require("../../stores/tag/tagStore");
const vue_router_1 = require("vue-router");
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const NameHeaderCell_vue_1 = __importDefault(require("./HeaderCells/NameHeaderCell.vue"));
const SizeHeaderCell_vue_1 = __importDefault(require("./HeaderCells/SizeHeaderCell.vue"));
const TyreLabelingHeaderCell_vue_1 = __importDefault(require("./HeaderCells/TyreLabelingHeaderCell.vue"));
const IdHeaderCell_vue_1 = __importDefault(require("./HeaderCells/IdHeaderCell.vue"));
const ListPriceHeaderCell_vue_1 = __importDefault(require("./HeaderCells/ListPriceHeaderCell.vue"));
const WholesalePriceHeaderCell_vue_1 = __importDefault(require("./HeaderCells/WholesalePriceHeaderCell.vue"));
const RetailPriceHeaderCell_vue_1 = __importDefault(require("./HeaderCells/RetailPriceHeaderCell.vue"));
const CustomPriceHeaderCell_vue_1 = __importDefault(require("./HeaderCells/CustomPriceHeaderCell.vue"));
const StockHeaderCell_vue_1 = __importDefault(require("./HeaderCells/StockHeaderCell.vue"));
const CartHeaderCell_vue_1 = __importDefault(require("./HeaderCells/CartHeaderCell.vue"));
const NameCell_vue_1 = __importDefault(require("./Cells/NameCell.vue"));
const SizeCell_vue_1 = __importDefault(require("./Cells/SizeCell.vue"));
const TyreLabelingCell_vue_1 = __importDefault(require("./Cells/TyreLabelingCell.vue"));
const IdCell_vue_1 = __importDefault(require("./Cells/IdCell.vue"));
const ListPriceCell_vue_1 = __importDefault(require("./Cells/ListPriceCell.vue"));
const WholesalePriceCell_vue_1 = __importDefault(require("./Cells/WholesalePriceCell.vue"));
const RetailPriceCell_vue_1 = __importDefault(require("./Cells/RetailPriceCell.vue"));
const CustomPriceCell_vue_1 = __importDefault(require("./Cells/CustomPriceCell.vue"));
const StockCell_vue_1 = __importDefault(require("./Cells/StockCell.vue"));
const CartCell_vue_1 = __importDefault(require("./Cells/CartCell.vue"));
const DiscountRow_vue_1 = __importDefault(require("./Rows/DiscountRow.vue"));
const SeparatorRow_vue_1 = __importDefault(require("./Rows/SeparatorRow.vue"));
const PriceOptionsRow_vue_1 = __importDefault(require("./Rows/PriceOptionsRow.vue"));
const NameHeaderRow_vue_1 = __importDefault(require("./HeaderRows/NameHeaderRow.vue"));
const productListStore_1 = require("../../stores/product/list/productListStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductListTable',
    props: {
        products: null,
        switches: null,
        id: null,
        tableName: null,
        sortBy: null,
        sortDir: null,
        disabledColumns: null
    },
    emits: ['update:sortBy', 'update:sortDir'],
    setup(__props, { emit }) {
        const props = __props;
        const tagStore = (0, tagStore_1.useTagStore)();
        const router = (0, vue_router_1.useRouter)();
        const productListStore = (0, productListStore_1.useProductListStore)();
        const SortBy = {
            NAME: 'name',
            LIST_PRICE: 'listPrice',
            WHOLESALE_PRICE: 'wholesalePrice',
            RETAIL_PRICE: 'retailPrice',
            CUSTOM_PRICE: 'customPrice',
            STOCK: 'stock'
        };
        const Columns = {
            NAME: 'name',
            SIZE: 'size',
            TYRE_LABELING: 'tyreLabeling',
            ID: 'id',
            LIST_PRICE: 'listPrice',
            WHOLESALE_PRICE: 'wholesalePrice',
            RETAIL_PRICE: 'retailPrice',
            CUSTOM_PRICE: 'customPrice',
            STOCK: 'stock',
            CART: 'cart'
        };
        const routeName = (0, vue_3.computed)(() => {
            const rawName = router.currentRoute.value.name;
            if (typeof rawName !== 'string')
                return '';
            // Ha van 'shop_' prefix, levágjuk.
            let name = rawName.startsWith('shop_') ? rawName.slice(5) : rawName;
            // snake_case-ből camelCase-t csinálunk.
            name = name.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
            // Első karaktert kisbetűsre alakítjuk.
            if (name.length > 0) {
                name = name.charAt(0).toLowerCase() + name.slice(1);
            }
            // Ha nem 'Search'-re végződik, hozzáadjuk a végére.
            if (!name.endsWith('Search')) {
                name += 'Search';
            }
            return name;
        });
        const sortedProducts = (0, vue_3.computed)(() => {
            var _a, _b;
            const currentSortBy = (_a = props.sortBy) !== null && _a !== void 0 ? _a : sortBy.value;
            const currentSortDir = (_b = props.sortDir) !== null && _b !== void 0 ? _b : sortDir.value;
            const direction = currentSortDir === 'asc' ? 1 : -1;
            return [...props.products].sort((a, b) => {
                const aValue = getProductValue(a, currentSortBy);
                const bValue = getProductValue(b, currentSortBy);
                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    return direction * (aValue - bValue);
                }
                return direction * compare(String(aValue), String(bValue));
            });
        });
        const tableId = (0, vue_3.computed)(() => { var _a, _b; return (_a = props.id) !== null && _a !== void 0 ? _a : `product-list-table-${(_b = (0, vue_3.getCurrentInstance)()) === null || _b === void 0 ? void 0 : _b.uid}`; });
        const tooltipTexts = {
            orderable: (0, i18n_1.trans)("product_not_in_stock_notice", "This product is unfortunately not in stock, but can be obtained from the manufacturer.", "tyre_filter") +
                " " +
                (0, i18n_1.trans)("contact_sales_representative_for_product_availability_notice", "Contact your sales representative for product availability and delivery times.", "tyre_filter"),
            limited: (0, i18n_1.trans)("product_only_available_on_a_limited_basis_notice", "This product is only available on a limited basis in Marso's national inventory.", "tyre_filter") +
                " " +
                (0, i18n_1.trans)("sales_representative_will_inform_notice", "When ordering, your sales representative will inform you about the availability and delivery time of the product.", "tyre_filter"),
            recycle: (0, i18n_1.trans)("recycle_icon_popup_epr_price", "EPR price", "search"),
            "warehouse-specific-price": (0, i18n_1.trans)("warehouse_specific_price_tooltip", "The product is available in our external warehouses, where prices may vary by warehouse.", "product_list_table")
        };
        const cssTooltipVars = Object.entries(tooltipTexts)
            .map(([key, value]) => `--tooltip-${key}: "${value.replace(/"/g, '\\"')}"`)
            .join('; ');
        const visiblePriceOptions = (0, vue_3.ref)(new Map());
        const sortDir = (0, vue_3.ref)('asc');
        const sortBy = (0, vue_3.ref)(SortBy.NAME);
        const getAriaSort = (column) => {
            var _a, _b;
            // During pair search, only name column should indicate sorting
            const pairSearch = tagStore.tags.switches.pairSearchSwitch.value;
            if (pairSearch && column !== SortBy.NAME)
                return 'none';
            const currentSortBy = (_a = props.sortBy) !== null && _a !== void 0 ? _a : sortBy.value;
            if (currentSortBy !== column)
                return 'none';
            const currentSortDir = (_b = props.sortDir) !== null && _b !== void 0 ? _b : sortDir.value;
            return currentSortDir === 'asc' ? 'ascending' : 'descending';
        };
        const getProductValue = (product, sortByParam) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            switch (sortByParam) {
                case SortBy.NAME: {
                    if (product.type === 'valve') {
                        return (_a = product.productName) !== null && _a !== void 0 ? _a : '';
                    }
                    else if (tagStore.tags.columns.nameColumn.value === 'tyre') {
                        return product.brandName || product.treadCode || '';
                    }
                    else {
                        return (_b = product.productName) !== null && _b !== void 0 ? _b : '';
                    }
                }
                case SortBy.LIST_PRICE:
                    return (_d = (_c = product.prices) === null || _c === void 0 ? void 0 : _c.priceListNet) !== null && _d !== void 0 ? _d : 0;
                case SortBy.WHOLESALE_PRICE:
                    return (_f = (_e = product.prices) === null || _e === void 0 ? void 0 : _e.priceDiscountNet) !== null && _f !== void 0 ? _f : 0;
                case SortBy.RETAIL_PRICE:
                    return (_h = (_g = product.prices) === null || _g === void 0 ? void 0 : _g.priceRetailNet) !== null && _h !== void 0 ? _h : 0;
                case SortBy.CUSTOM_PRICE:
                    return (_k = (_j = product.prices) === null || _j === void 0 ? void 0 : _j.priceCustomNet) !== null && _k !== void 0 ? _k : 0;
                case SortBy.STOCK:
                    return (_m = (_l = product.stocks) === null || _l === void 0 ? void 0 : _l.stockCountry) !== null && _m !== void 0 ? _m : 0;
                default:
                    return '';
            }
        };
        const compare = (a, b) => {
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        };
        const toggleSort = (column) => {
            var _a, _b;
            if (tagStore.tags.switches.pairSearchSwitch.value && column !== SortBy.NAME)
                return;
            const currentSortBy = (_a = props.sortBy) !== null && _a !== void 0 ? _a : sortBy.value;
            const currentSortDir = (_b = props.sortDir) !== null && _b !== void 0 ? _b : sortDir.value;
            let newSortBy = currentSortBy;
            let newSortDir = currentSortDir;
            if (newSortBy === column) {
                newSortDir = newSortDir === 'asc' ? 'desc' : 'asc';
            }
            else {
                newSortBy = column;
                newSortDir = 'asc';
            }
            if (props.sortBy !== undefined) {
                emit('update:sortBy', newSortBy);
            }
            else {
                sortBy.value = newSortBy;
            }
            if (props.sortDir !== undefined) {
                emit('update:sortDir', newSortDir);
            }
            else {
                sortDir.value = newSortDir;
            }
        };
        const isColumnEnabled = (column) => {
            var _a;
            return ((_a = props.disabledColumns) === null || _a === void 0 ? void 0 : _a[column]) !== true;
        };
        (0, vue_3.onMounted)(() => {
            tagStore.calculateTags(routeName.value, props.switches);
        });
        (0, vue_3.watch)([routeName, () => props.switches], ([newRoute, newSwitches], [oldRoute, oldSwitches]) => {
            // Csak akkor fut, ha a routeName vagy a switches property-k ténylegesen változnak.
            const switchesChanged = JSON.stringify(newSwitches) !== JSON.stringify(oldSwitches);
            if (newRoute !== oldRoute || switchesChanged) {
                tagStore.calculateTags(newRoute, newSwitches);
            }
        }, { deep: true });
        (0, vue_3.watch)(() => productListStore.loading, (loading, prev) => {
            if (prev === true && loading === false) {
                visiblePriceOptions.value.clear();
            }
        });
        return (_ctx, _cache) => {
            return (__props.products.length > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", {
                    key: 0,
                    id: (0, vue_2.unref)(tableId),
                    class: "relative border-separate lg:border-collapse border-spacing-1 lg:border-spacing-0 table-auto min-w-full shadow-lg rounded mt-4",
                    style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(cssTooltipVars))
                }, [
                    (0, vue_2.createElementVNode)("thead", {
                        id: `${(0, vue_2.unref)(tableId)}-header`,
                        class: "sticky top-14 z-[1]"
                    }, [
                        (0, vue_2.createVNode)(NameHeaderRow_vue_1.default, { "table-name": __props.tableName }, null, 8, ["table-name"]),
                        (0, vue_2.createElementVNode)("tr", {
                            id: `${(0, vue_2.unref)(tableId)}-header-row`,
                            class: "hidden lg:table-row border-b-[0.5rem] border-gray border-solid"
                        }, [
                            (isColumnEnabled((0, vue_2.unref)(Columns).NAME))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NameHeaderCell_vue_1.default, {
                                    key: 0,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).NAME),
                                    onToggleSort: _cache[0] || (_cache[0] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).NAME)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).SIZE))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SizeHeaderCell_vue_1.default, {
                                    key: 1,
                                    "table-id": (0, vue_2.unref)(tableId)
                                }, null, 8, ["table-id"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).TYRE_LABELING))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreLabelingHeaderCell_vue_1.default, {
                                    key: 2,
                                    "table-id": (0, vue_2.unref)(tableId)
                                }, null, 8, ["table-id"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).ID))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(IdHeaderCell_vue_1.default, {
                                    key: 3,
                                    "table-id": (0, vue_2.unref)(tableId)
                                }, null, 8, ["table-id"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).LIST_PRICE))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListPriceHeaderCell_vue_1.default, {
                                    key: 4,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).LIST_PRICE),
                                    onToggleSort: _cache[1] || (_cache[1] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).LIST_PRICE)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).WHOLESALE_PRICE))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(WholesalePriceHeaderCell_vue_1.default, {
                                    key: 5,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).WHOLESALE_PRICE),
                                    onToggleSort: _cache[2] || (_cache[2] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).WHOLESALE_PRICE)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).RETAIL_PRICE))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RetailPriceHeaderCell_vue_1.default, {
                                    key: 6,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).RETAIL_PRICE),
                                    onToggleSort: _cache[3] || (_cache[3] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).RETAIL_PRICE)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).CUSTOM_PRICE))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomPriceHeaderCell_vue_1.default, {
                                    key: 7,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).CUSTOM_PRICE),
                                    onToggleSort: _cache[4] || (_cache[4] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).CUSTOM_PRICE)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).STOCK))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(StockHeaderCell_vue_1.default, {
                                    key: 8,
                                    "table-id": (0, vue_2.unref)(tableId),
                                    "aria-sort": getAriaSort((0, vue_2.unref)(SortBy).STOCK),
                                    onToggleSort: _cache[5] || (_cache[5] = ($event) => (toggleSort((0, vue_2.unref)(SortBy).STOCK)))
                                }, null, 8, ["table-id", "aria-sort"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (isColumnEnabled((0, vue_2.unref)(Columns).CART))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CartHeaderCell_vue_1.default, {
                                    key: 9,
                                    "table-id": (0, vue_2.unref)(tableId)
                                }, null, 8, ["table-id"]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 8, _hoisted_3)
                    ], 8, _hoisted_2),
                    (0, vue_2.createElementVNode)("tbody", {
                        id: `${(0, vue_2.unref)(tableId)}-body`,
                        class: "bg-transparent divide-gray"
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(sortedProducts), (product, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                                key: `${product.id}-${index}`
                            }, [
                                (0, vue_2.createElementVNode)("tr", {
                                    id: `product-list-table-body-row-${product.id}`,
                                    class: "block lg:table-row bg-white text-sm border-t-[1rem] lg:border-t-[0.5rem] border-transparent border-solid !mb-0 !lg:mb-auto"
                                }, [
                                    (isColumnEnabled((0, vue_2.unref)(Columns).NAME))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NameCell_vue_1.default, {
                                            key: 0,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).SIZE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SizeCell_vue_1.default, {
                                            key: 1,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).TYRE_LABELING))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreLabelingCell_vue_1.default, {
                                            key: 2,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).ID))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(IdCell_vue_1.default, {
                                            key: 3,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).LIST_PRICE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListPriceCell_vue_1.default, {
                                            key: 4,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).WHOLESALE_PRICE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(WholesalePriceCell_vue_1.default, {
                                            key: 5,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).RETAIL_PRICE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RetailPriceCell_vue_1.default, {
                                            key: 6,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).CUSTOM_PRICE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomPriceCell_vue_1.default, {
                                            key: 7,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).STOCK))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(StockCell_vue_1.default, {
                                            key: 8,
                                            products: (0, vue_2.unref)(sortedProducts),
                                            product: product,
                                            "visible-price-options": visiblePriceOptions.value
                                        }, null, 8, ["products", "product", "visible-price-options"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isColumnEnabled((0, vue_2.unref)(Columns).CART))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CartCell_vue_1.default, {
                                            key: 9,
                                            product: product
                                        }, null, 8, ["product"]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 8, _hoisted_5),
                                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(PriceOptionsRow_vue_1.default, {
                                            product: product,
                                            "visible-price-options": visiblePriceOptions.value,
                                            "table-id": (0, vue_2.unref)(tableId)
                                        }, null, 8, ["product", "visible-price-options", "table-id"])
                                    ]),
                                    _: 2
                                }, 1024),
                                (0, vue_2.createVNode)(DiscountRow_vue_1.default, { product: product }, null, 8, ["product"]),
                                (0, vue_2.createVNode)(SeparatorRow_vue_1.default, {
                                    products: (0, vue_2.unref)(sortedProducts),
                                    product: product,
                                    index: index
                                }, null, 8, ["products", "product", "index"])
                            ], 64));
                        }), 128))
                    ], 8, _hoisted_4)
                ], 12, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
